import { Chip, Typography } from '@mui/material';

type UserGlobalRolesProps = {
    title: string;
    globalRoles: string[];
};

export function UserGlobalRoles({
    title,
    globalRoles
}: Readonly<UserGlobalRolesProps>) {
    return (
        <div style={{ marginLeft: '2.5rem', marginTop: '0.7rem' }}>
            <Typography color="info.medium" variant="body2">{title}</Typography>
            {globalRoles?.length > 0 && globalRoles.map((role) =>
                <Chip key={role}
                    label={role}
                    sx={{ backgroundColor: 'info', marginLeft: '3px' }}
                    size='small'
                    id='outlined'
                />)}
        </div>
    );
}
